"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Linkedin, X } from "lucide-react";
function FooterNavigation() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <nav className="flex flex-wrap gap-6 justify-center animate-pulse">
        <div className="h-4 w-16 bg-muted-dark/30 rounded" />
        <div className="h-4 w-20 bg-muted-dark/30 rounded" />
        <div className="h-4 w-24 bg-muted-dark/30 rounded" />
      </nav>;
  }
  return <nav className="flex flex-wrap gap-6 justify-center animate-fade-in-up">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-foreground-dark/70 hover:text-foreground-dark transition-colors duration-[var(--duration-medium)] text-sm">
          {item.label}
        </Link>)}
    </nav>;
}
function Footer() {
  const socialLinks = [{
    icon: Linkedin,
    href: "https://www.linkedin.com/company/339970",
    label: "LinkedIn"
  }];
  return <footer className="bg-dark-background text-foreground-dark border-t border-border-strong/30 py-8">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-6">
          <div className="text-center md:text-left animate-fade-in-up">
            <p className="text-sm text-foreground-dark/70">
              <strong className="text-foreground-dark">Cohesion Recruitment t/a Activate</strong>
            </p>
            <p className="text-sm text-foreground-dark/70 mt-1">Stratford Court, Cranmore Boulevard, Solihull, B90 4QT</p>
            <p className="text-sm text-foreground-dark/70 mt-1">
              <Link to="tel:0121-713 8320" className="hover:text-foreground-dark transition-colors">
                0121-713 8320
              </Link>
              {" | "}
              <Link to="mailto:info@cohesionrecruitment.com" className="hover:text-foreground-dark transition-colors">
                info@cohesionrecruitment.com
              </Link>
            </p>
          </div>

          <div className="flex gap-4 animate-fade-in-up-delay-100">
            {socialLinks.map((social, i) => <Link key={social.label} to={social.href} data-index={i} newTab className="text-foreground-dark/70 hover:text-foreground-dark hover:scale-110 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]" aria-label={social.label}>
                <social.icon className="size-5" />
              </Link>)}
          </div>
        </div>

        <MenuProvider menu_id="26" className="mb-6">
          <FooterNavigation />
        </MenuProvider>

        <div className="text-center text-xs text-foreground-dark/50 pt-4 border-t border-border-strong/20 animate-fade-in-up-delay-200">
          © {new Date().getFullYear()} Cohesion Recruitment Ltd. All rights reserved.
        </div>
      </div>
    </footer>;
}
export default Footer;